import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import PersonIcon from "@material-ui/icons/PersonRounded";
import clsx from "clsx";
import logo from "../../../../../assets/logoWithoutName.png";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  dxAIAdminMenu,
  orgAdminMenu,
  ROLES,
  superAdminMenu,
  userMenu,
  userMenuDoctor,
} from "../../../../../utilities/constants";
import { getUserInfo } from "../../../../../utilities/storage";
import { getLoggedInUserByIdRequest } from "../../../../Auth/AuthApiActions";
import { useStyles } from "./styles";

const AppDrawer = ({
  open,
  getUserById,
  user,
  selectedDept,
  updates,
}) => {
  const classes = useStyles();
  const role = getUserInfo().Roles[0].name;

  const renderDrawerMenu = () => {
    // eslint-disable-next-line default-case
    switch (role) {
      case ROLES.ROLE_SUPER_ADMIN:
        return dxAIAdminMenu.map((menu, index) => {
          return (
            <ListItem
              key={index}
              className={classes.item}
              disableGutters
              component={NavLink}
              to={menu["path"]}
              activeClassName={classes.active}
              button
            >
              <Button className={classes.button}>
                <Tooltip title={menu["name"]} placement="right">
                  <Box className={classes.icon}>{menu["icon"]}</Box>
                </Tooltip>
                <Typography variant="body1">
                  {open ? `${menu["name"]}` : ""}
                </Typography>
              </Button>
            </ListItem>
          );
        });
      case ROLES.ROLE_SYSTEM_ADMIN:
        return superAdminMenu.map((menu, index) => {
          return (
            <ListItem
              key={index}
              className={classes.item}
              disableGutters
              component={NavLink}
              to={menu["path"]}
              activeClassName={classes.active}
              button
            >
              <Button className={classes.button}>
                <Tooltip title={menu["name"]} placement="right">
                  <Box className={classes.icon}>{menu["icon"]}</Box>
                </Tooltip>
                <Typography variant="body1">
                  {open ? `${menu["name"]}` : ""}
                </Typography>
              </Button>
            </ListItem>
          );
        });
      case ROLES.ROLE_CLINIC_OWNER:
        return superAdminMenu.map((menu, index) => {
          return (
            <ListItem
              key={index}
              className={classes.item}
              disableGutters
              component={NavLink}
              to={menu["path"]}
              activeClassName={classes.active}
              button
            >
              <Button className={classes.button}>
                <Tooltip title={menu["name"]} placement="right">
                  <Box className={classes.icon}>{menu["icon"]}</Box>
                </Tooltip>
                <Typography variant="body1">
                  {open ? `${menu["name"]}` : ""}
                </Typography>
              </Button>
            </ListItem>
          );
        });

      case ROLES.ROLE_ORG_ADMIN:
        return orgAdminMenu.map((menu, index) => {
          const orgId = user?.Admin?.Organization[0]?.id;
          const resolvedPath = menu.path.replace(":id", orgId);
          return (
            <ListItem
              key={index}
              className={classes.item}
              disableGutters
              component={NavLink}
              to={resolvedPath}
              activeClassName={classes.active}
              button
            >
              <Button className={classes.button}>
                <Tooltip title={menu.name} placement="right">
                  <Box className={classes.icon}>{menu.icon}</Box>
                </Tooltip>
                <Typography variant="body1">
                  {open ? `${menu.name}` : ""}
                </Typography>
              </Button>
            </ListItem>
          );
        });

      case ROLES.ROLE_DOCTOR:
        // "New Updates" is intentionally omitted here — the header notification
        // bell already covers it, so we avoid a duplicate entry in the drawer.
        return userMenuDoctor
          .filter((menu) => menu.path !== "/newUpdates")
          .map((menu, index) => {
            const isPatients = menu.path === "/patients";
            return (
              <ListItem
                key={index}
                className={classes.item}
                disableGutters
                component={NavLink}
                to={menu["path"]}
                activeClassName={classes.active}
                button
              >
                <Button className={classes.button}>
                  {!isPatients && (
                    <Tooltip title={menu["name"]} placement="right">
                      <Box className={classes.icon}>
                        {menu["isBadge"] ? (
                          <Badge
                            badgeContent={
                              updates
                                ? updates.count
                                : selectedDept
                                ? selectedDept.notifications
                                : 0
                            }
                            color="secondary"
                            showZero={false}
                          >
                            {menu["icon"]}
                          </Badge>
                        ) : (
                          menu["icon"]
                        )}
                      </Box>
                    </Tooltip>
                  )}
                  {isPatients && (
                    <Tooltip title={"Patients"} placement="right">
                      <Box className={classes.icon}>
                        <PersonIcon />
                      </Box>
                    </Tooltip>
                  )}
                  <Typography variant="body1">
                    {open ? (isPatients ? "Patients" : `${menu["name"]}`) : ""}
                  </Typography>
                </Button>
              </ListItem>
            );
          });

      case ROLES.ROLE_RECEPTIONIST:
      case ROLES.ROLE_PHARMACIST:
      case ROLES.ROLE_THERAPIST:
        return userMenu.map((menu, index) => {
          return (
            <ListItem
              key={index}
              className={classes.item}
              disableGutters
              component={NavLink}
              to={menu["path"]}
              activeClassName={classes.active}
              button
            >
              <Button className={classes.button}>
                {index === 2 ? (
                  <>
                    <Tooltip title={"Patients"} placement="right">
                      <Box className={classes.icon}>
                        <PersonIcon />
                      </Box>
                    </Tooltip>
                    <Typography variant="body1">Patients</Typography>
                  </>
                ) : (
                  <>
                    <Tooltip title={menu["name"]} placement="right">
                      <Box className={classes.icon}>
                        {menu["isBadge"] ? (
                          <Badge
                            badgeContent={
                              updates
                                ? updates.count
                                : selectedDept
                                ? selectedDept.notifications
                                : 0
                            }
                            color="secondary"
                            showZero={false}
                          >
                            {menu["icon"]}
                          </Badge>
                        ) : (
                          menu["icon"]
                        )}
                      </Box>
                    </Tooltip>
                    <Typography variant="body1">
                      {open ? `${menu["name"]}` : ""}
                    </Typography>
                  </>
                )}
              </Button>
            </ListItem>
          );
        });
    }
  };

  useEffect(() => {
    getUserById(getUserInfo().id).then((res) => {});
  }, [getUserById]);

  return (
    <Drawer
      variant="permanent"
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open,
      })}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        }),
      }}
    >
      <Box className={classes.drawerContentContainer}>
        <Box className={classes.drawerInnerContentContainer}>
          <Box>
            <Box className={classes.brand}>
              <img src={logo} className={classes.brandLogo} alt="eira" />
              <Typography className={classes.brandName}>Eira</Typography>
            </Box>

            <Typography className={classes.menuCaption}>Menu</Typography>

            <Box
              className={
                role === ROLES.ROLE_SYSTEM_ADMIN ? classes.menuHeight : ""
              }
            >
              <List disablePadding>{renderDrawerMenu()}</List>
            </Box>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.loggedInUser,
    selectedDept: state.ayucareUsers.selectedDept,
    updates: state.newUpdates.updates,
  };
};

const mapDispatchToProp = (dispatch) => {
  return {
    getUserById: (id) => {
      return dispatch(getLoggedInUserByIdRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProp)(AppDrawer);
